import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <motion.header
      initial={{ y: -30, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="bg-softgreen shadow-md sticky top-0 z-50"
    >
      <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">
        {/* LOGO */}
        <a href="/" className="flex items-center space-x-2">
          <img src="/logo.png" alt="Logo Story Brand" className="h-10 w-auto" />
        </a>

        {/* DESKTOP NAVIGATION */}
        <nav className="hidden md:flex space-x-8 font-medium text-dark">
          <a href="/" className="hover:text-primary transition">Accueil</a>
          <a href="#services" className="hover:text-primary transition">Services</a>
          <a href="#about" className="hover:text-primary transition">À propos</a>
          <a href="#contact" className="hover:text-primary transition">Contact</a>
        </nav>

        {/* MOBILE TOGGLE */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="md:hidden text-dark focus:outline-none"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            <path d={menuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"} />
          </svg>
        </button>
      </div>

      {/* MOBILE NAVIGATION */}
      <AnimatePresence>
        {menuOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="md:hidden bg-softgreen px-4 pb-4 space-y-2 font-medium text-dark"
          >
            <a href="/" onClick={() => setMenuOpen(false)} className="block py-2 hover:text-primary transition">Accueil</a>
            <a href="#services" onClick={() => setMenuOpen(false)} className="block py-2 hover:text-primary transition">Services</a>
            <a href="#about" onClick={() => setMenuOpen(false)} className="block py-2 hover:text-primary transition">À propos</a>
            <a href="#contact" onClick={() => setMenuOpen(false)} className="block py-2 hover:text-primary transition">Contact</a>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
}
